module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step2b_Image4a.58441f7f.jpg";